import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initMetaPixel } from './lib/metaPixel';
initMetaPixel();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-119" data-mp="218wcwwcn3w8c" />);
}